import { Injectable } from '@angular/core';
import { IShipmentDetailsInfo } from 'app-modules/core/models/shipment-detail-info.interface';

@Injectable()
export abstract class ShipmentDetailPopup {
    abstract OpenShipmentDetailPopup(shipment: IShipmentDetailsInfo, isFromUnAuthUrl?: boolean): void;
}
